export const fadeInUp = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] },
};

export const staggerContainer = {
  initial: { opacity: 0 },
  animate: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
      delayChildren: 0.2,
    },
  },
  exit: { opacity: 0 },
};

export const staggerItem = {
  initial: { opacity: 0, y: 10 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.4, ease: [0.22, 1, 0.36, 1] },
};

// Disable animations on mobile - use CSS prefers-reduced-motion or check window size
export const getMobileAnimations = () => {
  if (typeof window !== 'undefined' && window.innerWidth <= 768) {
    return {
      fadeInUp: {},
      staggerContainer: {},
      staggerItem: {},
    };
  }
  return { fadeInUp, staggerContainer, staggerItem };
};

export const hoverLift = {
  rest: { y: 0, scale: 1 },
  hover: { y: -4, scale: 1.02 },
  transition: { duration: 0.2, ease: [0.22, 1, 0.36, 1] },
};

export const tileEntrance = {
  initial: { opacity: 0, scale: 0.95 },
  animate: { opacity: 1, scale: 1 },
  transition: { duration: 0.4, ease: [0.22, 1, 0.36, 1] },
};

export const inputFocus = {
  rest: { scale: 1 },
  focus: { scale: 1.02 },
  transition: { duration: 0.2, ease: [0.22, 1, 0.36, 1] },
};
